/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type ObservationFulfillmentItem = {
    /**
     * Display name of the observation item
     */
    displayName: string;
    /**
     * The observation category to which the observation belongs
     */
    category: ObservationFulfillmentItem.category;
    /**
     * The type of observation item
     */
    type: ObservationFulfillmentItem.type;
    /**
     * Indicates whether the observation's fulfillment is required
     */
    isRequired: boolean;
    /**
     * Indicates the fulfillment status, regardless of whether the observation is required
     */
    status: ObservationFulfillmentItem.status;
};

export namespace ObservationFulfillmentItem {

    /**
     * The observation category to which the observation belongs
     */
    export enum category {
        CARDIOMETABOLIC_HEALTH = 'CARDIOMETABOLIC_HEALTH',
        KIDNEY_HEALTH = 'KIDNEY_HEALTH',
        LIVER_HEALTH = 'LIVER_HEALTH',
    }

    /**
     * The type of observation item
     */
    export enum type {
        CHOLESTEROL_TYPE = 'CHOLESTEROL_TYPE',
        GLUCOSE_TYPE = 'GLUCOSE_TYPE',
        A1C_TYPE = 'A1C_TYPE',
        HDL_TYPE = 'HDL_TYPE',
        LDL_TYPE = 'LDL_TYPE',
        TRIGLYCERIDES_TYPE = 'TRIGLYCERIDES_TYPE',
        BICARBONATE_TYPE = 'BICARBONATE_TYPE',
        BUN_TYPE = 'BUN_TYPE',
        CALCIUM_TYPE = 'CALCIUM_TYPE',
        CHLORIDE_TYPE = 'CHLORIDE_TYPE',
        CREATININE_TYPE = 'CREATININE_TYPE',
        EGFR_TYPE = 'EGFR_TYPE',
        POTASSIUM_TYPE = 'POTASSIUM_TYPE',
        SODIUM_TYPE = 'SODIUM_TYPE',
        UACR_TYPE = 'UACR_TYPE',
        ALBUMIN_TYPE = 'ALBUMIN_TYPE',
        BILIRUBIN_TYPE = 'BILIRUBIN_TYPE',
        LFT_OR_ALT_AST_TYPE = 'LFT_OR_ALT_AST_TYPE',
        PROTEIN_TYPE = 'PROTEIN_TYPE',
    }

    /**
     * Indicates the fulfillment status, regardless of whether the observation is required
     */
    export enum status {
        COMPLETE = 'COMPLETE',
        INCOMPLETE = 'INCOMPLETE',
    }


}

